import axios from 'axios';
import _ from 'lodash';
import Constants from '../constants';
import { IExternalAttributeVm } from '../models';
import { IAttributeVm } from '../models/IAttributeVm';

export async function getConfiguredParticipantAttributes(surveyId: number): Promise<IExternalAttributeVm[]> {
	const res = await axios.get(Constants.API_EXTERNAL_ATTRIBUTES.replace('{surveyId}', surveyId.toString()));
	return res.data;
}

export async function getConfiguredClientAttributesByAudience(audienceId: number): Promise<IAttributeVm[]> {
	const res = await axios.get(Constants.API_URL + '/clientattributes/audience/' + audienceId);
	return res.data;
}
